// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableBox[data-v-a2e4d032]{height:calc(100% - 260px)}.colorStyle[data-v-a2e4d032]{color:red}.formbox[data-v-a2e4d032] ,.headebut[data-v-a2e4d032]{width:60%;margin:0 auto}.headebut[data-v-a2e4d032]{padding-left:100px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
